import { Maybe } from "../models/common/generic-types";

export default function formatNumber(n: Maybe<number> | undefined): string {
	if (n == null) {
		return `${-1}`;
	}

	const fixedNumber = n % 1 === 0 ? n : n.toFixed(2);

	return `${fixedNumber}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}
